import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { canAccessPath } from "../lib/permissions";
import { ShieldAlert } from "lucide-react";

/**
 * Encapsule une route admin-only.
 * Si un opérateur tente d'y accéder via URL directe, on affiche un écran "Accès refusé"
 * (au lieu de rediriger silencieusement, pour qu'il comprenne la situation).
 */
export default function RoleProtected({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null || user === false) {
    return <Navigate to="/login" replace />;
  }
  if (canAccessPath(user.role, location.pathname)) {
    return children;
  }
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="forbidden-page">
      <div className="max-w-md text-center bg-white border border-[#E5E5E0] rounded-xl p-8 shadow-sm">
        <div className="w-12 h-12 mx-auto rounded-full bg-[#FCEEEA] flex items-center justify-center mb-4">
          <ShieldAlert className="w-6 h-6 text-[#C05C47]" />
        </div>
        <h2 className="font-heading text-xl font-medium text-[#1A1C1A]">Accès refusé</h2>
        <p className="text-sm text-[#575A57] mt-2">
          Cette section est réservée aux administrateurs. Si vous pensez qu'il s'agit d'une erreur, contactez votre responsable.
        </p>
      </div>
    </div>
  );
}
